import { render } from "./MyTransportBookings.vue?vue&type=template&id=b98e8b66&scoped=true"
import script from "./MyTransportBookings.vue?vue&type=script&lang=js"
export * from "./MyTransportBookings.vue?vue&type=script&lang=js"

import "./MyTransportBookings.vue?vue&type=style&index=0&id=b98e8b66&lang=css"
import "./MyTransportBookings.vue?vue&type=style&index=1&id=b98e8b66&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98e8b66"]])

export default __exports__